import React, { useContext } from "react";
import Button from "../../../shared/components/forms/Button";
import ModalContext from "../../../shared/context/ModalContext";

function AlertModal({ message, buttonText, onYes, automaticModal = true }) {
    const modalContext = useContext(ModalContext);

    return (
        <div className="modal__inner">
            <div dangerouslySetInnerHTML={{ __html: message }} />
            <div className="modal__buttons flex-end">
                {automaticModal && (
                    <Button
                        type="button"
                        className="primary-cta modal__button"
                        onClick={() => {
                            if (onYes) {
                                onYes();
                            }
                            modalContext.hideModal();
                        }}
                    >
                        {buttonText || "OK"}
                    </Button>
                )}
            </div>
        </div>
    );
}

export default AlertModal;
